let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hNOX8")).then(() => parcelRequire('diBKM'));